export default __webpack_public_path__ + "static/media/prm-invite-cropped.3a30d331.png";